import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import { Image } from "expo-image";
import Images from "@/assets/images";
import Icons from "@/assets/icons";

const CheckItem = ({ text }: { text: string }) => (
  <View style={styles.checkItem}>
    <Icons.Check width={24} height={24} />
    <Text style={styles.checkText}>{text}</Text>
  </View>
);

export default function WelcomeSlideNew4() {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Manage your money better</Text>

      <View style={styles.chartsContainer}>
        <View style={styles.budgetCard}>
          <Image source={Images.budgetChart} style={styles.budgetImage} />
        </View>

        <View style={styles.networthCard}>
          <Image source={Images.networthChart} style={styles.networthImage} />
        </View>

        <View style={styles.spendingCard}>
          <Image source={Images.spendingChart} style={styles.spendingImage} />
        </View>
      </View>

      <View style={styles.checkList}>
        <CheckItem text="Keep track of your expenses" />
        <CheckItem text="Analyze your net worth" />
        <CheckItem text="Monitor transactions on your card" />
        <CheckItem text="Cancel subscriptions you don't use" />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 36,
    color: "#161D14",
    lineHeight: 39,
    letterSpacing: -0.72,
    marginBottom: 30,
    marginTop: 30,
  },
  chartsContainer: {
    height: 209,
    position: "relative",
    marginBottom: 50,
  },
  budgetCard: {
    position: "absolute",
    top: 0,
    zIndex: 1,
    right: 15,
  },
  budgetImage: {
    width: 183,
    height: 77,
  },
  networthCard: {
    position: "absolute",
    left: 20,
    top: 49,
    zIndex: 2,
  },
  networthImage: {
    width: 174,
    height: 111,
  },
  spendingCard: {
    position: "absolute",
    right: 40,
    top: 76,
    zIndex: 3,
  },
  spendingImage: {
    width: 199,
    height: 154,
  },
  checkList: {
    gap: 12,
  },
  checkItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  checkText: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    color: "#000000",
    opacity: 0.7,
    lineHeight: 23,
    flex: 1,
  },
});
